import { useEffect } from 'react';
import { shouldDeferToNativeClipboardShortcuts } from '../utils/overlayPointerGuard';

/**
 * Ctrl/Cmd+C, X, V, D for the flowchart. Repeats are ignored so a long paste
 * cannot start a second clone of every nested campaign.
 */
export function useClipboardShortcuts({
  selectedNodes,
  copySelectedNodes,
  pasteNodes,
  duplicateNodesDirect,
  onDeleteTasks,
  onAfterDelete,
}) {
  useEffect(() => {
    const handleKeyDown = async (e) => {
      if (e.repeat) return;
      if (shouldDeferToNativeClipboardShortcuts(e)) return;

      if ((e.ctrlKey || e.metaKey) && e.key === 'c') {
        if (selectedNodes.size > 0) {
          e.preventDefault();
          await copySelectedNodes();
        }
      }

      if ((e.ctrlKey || e.metaKey) && e.key === 'x') {
        if (selectedNodes.size > 0) {
          e.preventDefault();
          const copied = await copySelectedNodes();
          if (copied && onDeleteTasks) {
            const idsToDelete = Array.from(selectedNodes);
            onDeleteTasks(idsToDelete, { skipBridgePrompt: true });
            if (onAfterDelete) {
              setTimeout(() => {
                onAfterDelete(idsToDelete);
              }, 50);
            }
          }
        }
      }

      if ((e.ctrlKey || e.metaKey) && e.key === 'v') {
        e.preventDefault();
        await pasteNodes();
      }

      if ((e.ctrlKey || e.metaKey) && e.key === 'd') {
        if (selectedNodes.size > 0) {
          e.preventDefault();
          await duplicateNodesDirect(Array.from(selectedNodes));
        }
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [selectedNodes, copySelectedNodes, pasteNodes, duplicateNodesDirect, onDeleteTasks, onAfterDelete]);
}
